import React, { useRef, useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useLocation } from 'react-router-dom';

import '../patientForm.css';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import { ICONS, Loader, SuccessModal } from '@ohif/ui';
import { PatientPropsType } from '@custom/Utils/constants/interfaces';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _appointmentUrls, _attachementUrls, _commonUrls, _patientUrls } from '@custom/Utils/constants/apiUrls';
import { servicesManager } from '../../../app/src/App';
import { PatientDemographicFormSchema } from './schema';
import '../../global.css'
import { customStyle, getCurrencyContact } from '@custom/Utils/utils';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import sendAbhaOtpApi from '@custom/rtk-apis/abha/sendAbhaOtp';
import verifyAbhaOtpApi from '@custom/rtk-apis/abha/verifyAbhaOtp';
import { clearState as clearVerifyAbhaOtpState } from '@custom/store/slices/abha/verifyAbhaOtp';
import { clearState as clearSendAbhaOtpState } from '@custom/store/slices/abha/sendAbhaOtp';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import hospitalDetailApi from '@custom/rtk-apis/hospital/hospitalDetails';
import EnrollABHAviaAadhaar from '@custom/rtk-apis/abha/enrollViaAadhaar';
import VerifyOtpAndEnrollApi from '@custom/rtk-apis/abha/verifyOtpAndEnroll';

interface PatientFormValues {
  profilePic: string;
  firstName: string;
  lastName: string;
  middleName: string;
  gender: string;
  emailId: string;
  dob: Dayjs | null;
  age: string;
  height: string;
  weight: string;
  bloodGroup: string;
  maritalStatus: string;
  homeAddress: string;
  zipCode: string;
  country: string;
  state: string;
  city: string;
  phoneNumber: string;
  whatsappNumber: string;
  alternateNumber: string;
  sameAsPhoneNo: boolean;
}

const PatientDemoGraphics = (props: PatientPropsType) => {
  const [countryCode, setCountryCode] = useState({
    whatsappNumberCountryCode: "+91",
    phoneNumberCountryCode: "+91",
    alternateNumberCountryCode: "+91"
  });
  const [contactCountryCode, setContactCountryCode] = useState([])
  const [countryList, setCountryList] = useState([])
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [bloodGroup, setBloodGroup] = useState([])
  const [genderOptions, setGenderOption] = useState([])
  const [martialOption, setMartialOption] = useState([])
  const [previewUrl, setPreviewUrl] = useState(null);
  const [sameAsPhoneNo, setSameAsPhoneNo] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [OTP, setOTP] = useState("")
  const [showEnterOTPPopup, setShowEnterOTPPopup] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [verifyErrorMessage, setVerifyErrorMessage] = useState("")
  const [verifyOtpErrorMessage, setVerifyOtpErrorMessage] = useState("")
  const [txnId, setTxnId] = useState("");
  const [abhaData, setAbhaData] = useState({});
  const [organizationId, setOrganizationId] = useState({ idType: '', orgID: '' });
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');
  const [file, setFile] = useState();
  const [showAadhaarPopup, setShowAadhaarPopup] = useState(false);
  const [showAadhaarOTPPopup, setShowAadhaarOTPPopup] = useState(false);
  const [aadhaarErrorMessage, setAadhaarErrorMessage] = useState("");
  const [aadhaarOTP, setAadhaarOTP] = useState("");
  const [aadhaarMobile, setAadhaarMobile] = useState("");
  const [aadhaarTxnId, setAadhaarTxnId] = useState("");
  const [showAbhaNumberModal, setShowAbhaNumberModal] = useState(false);
  const [abhaNumber, setAbhaNumber] = useState("");
  const [displayedAbhaNumber, setDisplayedAbhaNumber] = useState("");
  const [aadhaarAbhaModal, setAadhaarAbhaModal] = useState({ open: false, abhaNumber: "" });
  const data = useLocation();
  const hospitalId = localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');

  const dispatch = useDispatch<AppDispatch>();
  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const hospitalDetailsData = useSelector((state: RootState) => state?.hospitalDetailsResponse);
  const {
    status: enrollAbhaStatus,
    data: enrollAbhaData,
    message: enrollAbhaMessage,
    loading: enrollAbhaLoading,
    error: enrollAbhaError
  } = useSelector(
    (state: RootState) => state.EnrollABHAviaAadhaarResponse
  );

  const {
    status: sendAbhaOtpStatus,
    data: sendAbhaOtpData,
    message: sendAbhaOtpMessage,
    loading: sendAbhaOtpLoading,
    error: sendAbhaOtpError
  } = useSelector(
    (state: RootState) => state.sendAbhaOtpResponse
  );

  const {
    status: verifyAbhaOtpStatus,
    data: verifyAbhaOtpData,
    message: verifyAbhaOtpMessage,
    loading: verifyAbhaOtpLoading,
    error: verifyAbhaOtpError
  } = useSelector(
    (state: RootState) => state.verifyAbhaOtpReponse
  );

  const {
    status: verifyAbhaOtpEnrollStatus,
    data: verifyAbhaOtpEnrollData,
    message: verifyAbhaOtpEnrollMessage,
    loading: verifyAbhaOtpEnrollLoading,
    error: verifyAbhaOtpEnrollError
  } = useSelector(
    (state: RootState) => state.VerifyOtpAndEnrollResponse
  );

  const formData = new FormData()
  const { uiNotificationService } = servicesManager.services

  const handleCountryCodeChange = (e: any) => {
    setCountryCode({ ...countryCode, [e.target.id]: e.target.value });
  };
  const [load, setLoad] = useState(false)
  const fileInputRef = useRef(null);
  const navigate = useNavigate()

  const handleOrganizationId = (idType, orgID) => {
    setOrganizationId({
      idType: idType || '',
      orgID: orgID || '',
    });
  };

  const idOptions = [
    { value: 'private', label: 'Private' },
    { value: 'government', label: 'Government' }
  ];

  useEffect(() => {
    if (billingGeneralSettingsData?.status === 'success' && billingGeneralSettingsData?.result?.currency) {
      const newCountryCode = getCurrencyContact(billingGeneralSettingsData.result.currency);
      setSelectedCountryCode(newCountryCode);
    }
  }, [billingGeneralSettingsData]);

  useEffect(() => {
    if (verifyAbhaOtpEnrollStatus === "SUCCESS") {
      setLoad(false);
      const abhaNum =
        verifyAbhaOtpEnrollData?.ABHAProfile?.ABHANumber ||
        verifyAbhaOtpEnrollData?.data?.ABHAProfile?.ABHANumber ||
        "";
      if (abhaNum) setDisplayedAbhaNumber(abhaNum);
      if (
        verifyAbhaOtpEnrollData?.message === "This account already exist" ||
        verifyAbhaOtpEnrollData?.data?.message === "This account already exist"
      ) {
        setAadhaarAbhaModal({
          open: true,
          abhaNumber: verifyAbhaOtpEnrollData?.ABHAProfile?.ABHANumber || verifyAbhaOtpEnrollData?.data?.ABHAProfile?.ABHANumber || "",
          message: "This account already exist"
        });
        setShowAadhaarOTPPopup(false);
      } else if (
        verifyAbhaOtpEnrollMessage === "Account created successfully" &&
        verifyAbhaOtpEnrollData?.ABHAProfile?.ABHANumber
      ) {
        setAadhaarAbhaModal({
          open: true,
          abhaNumber: verifyAbhaOtpEnrollData.ABHAProfile.ABHANumber,
          message: ""
        });
        setShowAadhaarOTPPopup(false);
      }
      setVerifyOtpErrorMessage("");
      setVerifyErrorMessage('');
    } else if (verifyAbhaOtpEnrollStatus === "FAILED") {
      setLoad(false);
      if (
        verifyAbhaOtpEnrollError &&
        typeof verifyAbhaOtpEnrollError === "string"
      ) {
        setVerifyOtpErrorMessage('Invalid OTP. Please try again.');
        setVerifyErrorMessage('');
      } else if (
        verifyAbhaOtpEnrollData?.msg &&
        typeof verifyAbhaOtpEnrollData.msg === "string"
      ) {
        setVerifyOtpErrorMessage('Invalid OTP. Please try again.');
        setVerifyErrorMessage('');
      } else {
        setVerifyOtpErrorMessage('Invalid OTP. Please try again.');
        setVerifyErrorMessage('');
      }
    }
  }, [verifyAbhaOtpEnrollStatus]);

  const getInitialValues = (): PatientFormValues => {
    const patientDetails = data?.state?.patientDetails?.patientDetail;
    const contactInfo = patientDetails?.contactInfo;
    const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency
      ? getCurrencyContact(billingGeneralSettingsData.result.currency)
    : '+91';

    if (data?.state?.mode == 'edit') {
      const editData = {
        profilePic: '',
        firstName: data.state?.patientDetails?.patientDetail?.firstName || "",
        lastName: data.state?.patientDetails?.patientDetail?.lastName || "",
        middleName: data.state?.patientDetails?.patientDetail?.middleName || "",
        gender: data.state?.patientDetails?.patientDetail?.gender || "",
        emailId: data.state?.patientDetails?.patientDetail?.email || "",
        dob: data.state?.patientDetails?.patientDetail?.dob ? dayjs(data.state?.patientDetails?.patientDetail?.dob) : null,
        height: data.state?.patientDetails?.patientDetail?.height || "",
        weight: data.state?.patientDetails?.patientDetail?.weight || "",
        bloodGroup: data.state?.patientDetails?.patientDetail?.bloodGroup || "",
        maritalStatus: data.state?.patientDetails?.patientDetail?.marital || "",
        homeAddress: data.state?.patientDetails?.patientDetail?.contactInfo?.addressLine1 || "",
        zipCode: data.state?.patientDetails?.patientDetail?.contactInfo?.zipCode || "",
        country: data.state?.patientDetails?.patientDetail?.contactInfo?.country || "",
        state: data.state?.patientDetails?.patientDetail?.contactInfo?.state || "",
        city: data.state?.patientDetails?.patientDetail?.contactInfo?.city || "",
        phoneNumber: data.state?.patientDetails?.patientDetail?.contactInfo?.mobileNo || "",
        whatsappNumber: data.state?.patientDetails?.patientDetail?.contactInfo?.whatsappNo || "",
        alternateNumber: data.state?.patientDetails?.patientDetail?.contactInfo?.alternateMobileNo || "",
        phoneNumberCountryCode: contactInfo?.dialCode || defaultCountryCode,
        whatsappNumberCountryCode: contactInfo?.whatsappNoDialCode || defaultCountryCode,
        alternateNumberCountryCode: contactInfo?.alternateMobileDialCode || defaultCountryCode,

        AbhaNumber: data.state?.patientDetails?.patientDetail?.ABHANo || "",
        sameAsPhoneNo: contactInfo?.mobileNo === contactInfo?.whatsappNo,
      };
      return editData
    } else if (data?.state?.mode == 'create') {
      const mobileNo = props?.patient?.contactInfo?.mobileNo || '';
      const whatsappNo = props?.patient?.contactInfo?.whatsappNo || '';

      const isSameAsPhoneNo = mobileNo && whatsappNo && mobileNo === whatsappNo;
      const dob = abhaData?.yearOfBirth && abhaData?.monthOfBirth && abhaData?.dayOfBirth
        ? dayjs(`${abhaData.yearOfBirth}-${abhaData.monthOfBirth}-${abhaData.dayOfBirth}`)
        : null;

      const initialData = {
        profilePic: '' || abhaData?.kycPhoto,
        firstName: props?.patient?.firstName || abhaData?.firstName || "",
        lastName: props?.patient?.lastName || abhaData?.lastName || "",
        middleName: props?.patient?.middleName || abhaData?.middleName || "",
        gender: props?.patient?.gender || (abhaData?.gender === "M" ? "Male" : abhaData?.gender === "F" ? "Female" : "Other") || "",
        emailId: props?.patient?.email || abhaData?.email || "",
        dob: props?.patient?.dob ? dayjs(props?.patient?.dob) : dob || null,
        height: props?.patient?.height || "",
        weight: props?.patient?.weight || "",
        bloodGroup: props?.patient?.bloodGroup || "",
        maritalStatus: props?.patient?.marital || "",
        homeAddress: props?.patient?.contactInfo?.addressLine1 || abhaData?.address || "",
        zipCode: props?.patient?.contactInfo?.zipCode || abhaData?.pincode || "",
        country: props?.patient?.contactInfo?.country || abhaData && "India" || "",
        state: props?.patient?.contactInfo?.state || abhaData?.stateName || "",
        city: props?.patient?.contactInfo?.city || abhaData?.townName || "",
        phoneNumber: props?.patient?.contactInfo?.mobileNo || abhaData?.mobile || "",
        whatsappNumber: props?.patient?.contactInfo?.whatsappNo || "",
        alternateNumber: props?.patient?.contactInfo?.alternateMobileNo || "",
        phoneNumberCountryCode: props?.patient?.contactInfo?.dialCode || defaultCountryCode,
        whatsappNumberCountryCode: props?.patient?.contactInfo?.whatsappNoDialCode || defaultCountryCode,
        alternateNumberCountryCode: props?.patient?.contactInfo?.alternateMobileDialCode || defaultCountryCode,

        AbhaNumber: props?.patient?.ABHANo || "",
        sameAsPhoneNo: isSameAsPhoneNo,
      };
      return initialData
    }
  };

  let initialValues = getInitialValues()

  useEffect(() => {
    setSameAsPhoneNo(initialValues.sameAsPhoneNo);
  }, [initialValues.sameAsPhoneNo]);

  const handleSave = async (values: any, { setSubmitting, setErrors }) => {
    const sameAsPhoneNo = values.phoneNumber === values.whatsappNumber;
    props.setContactNumber(values?.phoneNumber);
    props.setPatientName(values?.firstName + ' ' + values?.lastName);
    props.setPatientData(values);
    const payload = {
      "profileStep": props.PageNumber,
      "hospitalId": sessionStorage.getItem("hospitalId") || localStorage.getItem("hospitalId"),
      "firstName": values.firstName,
      "middleName": values.middleName,
      "lastName": values.lastName,
      "email": values.emailId,
      "gender": values.gender,
      "marital": values.maritalStatus,
      "height": values.height,
      "weight": values.weight,
      "bloodGroup": values.bloodGroup,
      "dob": values?.dob?.format('YYYY-MM-DD'),
      "age": values.age,
      "contactInfo": {
        "addressLine1": values.homeAddress,
        "dialCode": values.phoneNumberCountryCode,
        "mobileNo": String(values.phoneNumber),
        "whatsappNoDialCode": values.whatsappNumberCountryCode,
        "whatsappNo": String(values.whatsappNumber),
        "alternateMobileDialCode": values.alternateNumberCountryCode,
        "alternateMobileNo": String(values.alternateNumber),
        "country": values.country,
        "state": values.state,
        "city": values.city,
        "zipCode": values.zipCode,
        "sameAsPhoneNo": sameAsPhoneNo,
      },
      ...(organizationId.idType && { orgId: { type: organizationId.idType, value: organizationId.orgID } }),
    }
    setLoad(true)
    if (data.state?.mode == 'edit') {
      payload['_id'] = data.state?.patientDetails.patientDetail._id || ""
    } else if (data.state?.mode == 'create' && props.patientDocID) {
      payload['_id'] = props.patientDocID
    }

    const response = await apiRequest({ method: 'POST', endUrl: _patientUrls.add, headerType: 'json', body: payload })
    if (response.status) {
      setLoad(false);
      props.setPageNumber((prev: any) => prev + 1);
      props.setPatientDocID(response.result.id);
      handleFileSave(response.result.id);
    } else if (!response.status) {
      setLoad(false)
      uiNotificationService.show({
        title: "Error",
        type: "error",
        message: response.msg,
        position: "topRight"
      })
    }
  }

  const cancel = () => {
    navigate('/patientlist')
  }

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event: any) => {
    const file = event.target.files[0];
    setFile(event.target.files[0])
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFileSave = async (id: any) => {
    if (file) {
      formData.append('file', file)
      formData.append('type', 'PATIENT_PIC')
      formData.append('_id', id)
      const response = await apiRequest({ method: 'POST', endUrl: _attachementUrls.add, headerType: 'form', body: formData })
    }
  }

  useEffect(() => {
    fetchCommonData()
    dispatch(getBillingGeneralSettings());
    dispatch(hospitalDetailApi({ hospitalId: hospitalId }));
  }, [])

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        setCountryList(commonData?.result?.countryList)
        setContactCountryCode(commonData?.result?.countryCode)
        setBloodGroup(commonData?.result?.bloodGroup)
        setGenderOption(commonData?.result?.gender)
        setMartialOption(commonData?.result?.martialOption)
        props.setCommonData(commonData?.result)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchStates = async (country, state, type) => {
    const response: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.statecity, body: { type: type, countryCode: country, stateCode: state }, headerType: 'json' })
    if (response?.status) {
      if (type === 'state') {
        setStates(response.result);
      }
      else {
        setCities(response.result)
      }
      return true
    }
  }

  useEffect(() => {
    if (data.state?.patientDetails?.patientDetail) {
      console.log('location', data.state?.patientDetails?.patientDetail, props.patient)
    }
    console.log('patient', props.patient)
  }, [])

  useEffect(() => {
    const patientDetail = data.state?.patientDetails?.patientDetail;
    const contactInfo = patientDetail?.contactInfo || props.patient?.contactInfo;

    if (contactInfo?.country) {
      const flag = fetchStates(contactInfo.country, '', 'state');
      if (flag) {
        fetchStates(contactInfo.country, contactInfo.state, 'city');
      }
    }
  }, []);

  const handleGetOtp = (abhaNumber) => {
    setLoad(true);
    setShowOTP(true);
    setErrorMessage("");
    dispatch(sendAbhaOtpApi({ abhaNumber }));
    console.log("Generating OTP for ABHA Number:", abhaNumber);
  };

  useEffect(() => {
    if (sendAbhaOtpStatus === "SUCCESS") {
      setLoad(false);
      setSuccessMessage(sendAbhaOtpMessage);
      setSuccessModal(true);
      setTxnId(sendAbhaOtpData?.txnId);

      setTimeout(() => {
        setShowEnterOTPPopup(true);
      }, 1500);
    } else if (sendAbhaOtpStatus === "FAILED") {
      setLoad(false);
      setErrorMessage(sendAbhaOtpError || "Failed to generate OTP. Please try again.");
    }

    return () => {
      dispatch(clearSendAbhaOtpState());
    };
  }, [sendAbhaOtpStatus]);

  useEffect(() => {
    if (verifyAbhaOtpStatus === "SUCCESS") {
      setLoad(false);
      setSuccessMessage(verifyAbhaOtpMessage || "OTP verified successfully");
      setSuccessModal(true);
      setAbhaData(verifyAbhaOtpData);
      setShowEnterOTPPopup(false);
    } else if (verifyAbhaOtpStatus === "FAILED") {
      setLoad(false);
      setVerifyErrorMessage(verifyAbhaOtpError || "Invalid OTP. Please try again.");
      setShowEnterOTPPopup(true);
    }

    return () => {
      dispatch(clearVerifyAbhaOtpState());
    };
  }, [verifyAbhaOtpStatus]);


  const handleSubmitOtp = (OTP) => {
    if (!OTP) {
      alert("Please enter your OTP!");
      return;
    }

    setShowEnterOTPPopup(false);
    setLoad(true);

    const payload = { otp: OTP, txnId };
    dispatch(verifyAbhaOtpApi(payload));
  };

  const handleAbhaSubmit = (values) => {
    handleGetOtp(values.abhaNumber);
  };

const handleAadhaarEnroll = async (aadhaarNumber: string) => {
  if (!aadhaarNumber || !/^\d{12}$/.test(aadhaarNumber)) {
    setAadhaarErrorMessage("Please enter a valid 12-digit Aadhaar number.");
    return;
  }
  setLoad(true);
  setAadhaarErrorMessage("");
  dispatch(EnrollABHAviaAadhaar({ aadhaarNumber }));
};

  const handleAadhaarOTPSubmit = (otp: string, mobile: string) => {
    setLoad(true);
    setVerifyErrorMessage("");
    const payload = { otp, mobile, txnId: aadhaarTxnId };
    dispatch(VerifyOtpAndEnrollApi(payload));
  };

useEffect(() => {
  if (enrollAbhaStatus === "SUCCESS") {
    setLoad(false);
    setAadhaarTxnId(enrollAbhaData?.txnId || "");
    setTimeout(() => {
      setShowAadhaarPopup(false);
      setShowAadhaarOTPPopup(true);
    }, 500);
  } else if (enrollAbhaError) {
    setLoad(false);
    setShowEnterOTPPopup(false);
    let errorMsg = "Aadhaar number is invalid. Please try again.";
    if (
      typeof enrollAbhaError === "string" &&
      enrollAbhaError.includes("You can request for new OTP after 30 seconds")
    ) {
      errorMsg = enrollAbhaError;
    } else if (
      typeof enrollAbhaError === "object" &&
      enrollAbhaData?.msg?.message &&
      enrollAbhaData.msg.message.includes("You can request for new OTP after 30 seconds")
    ) {
      errorMsg = enrollAbhaData.msg.message;
    }
    setAadhaarErrorMessage(errorMsg);
    setShowAadhaarPopup(true);
  }
}, [enrollAbhaStatus, enrollAbhaError]);

  return (
    <section className='form__section'>
      <h1 className='form__section__title'>Patient Demographics</h1>
      {/* Profile Pic  */}
      <div className='formRow'>
        <div className="formCol">
          <div className="form__Field">
            <input
              className="form__uploadfiled"
              style={{ display: "none" }}
              type="file"
              id="profilePic"
              accept="image/*"
              name="profilePic"
              ref={fileInputRef}
              onChange={(e) => { handleFileChange(e) }}
            />
            <label onClick={handleButtonClick} className="form__uploadProfile" htmlFor="uploadProfile">
              <img className="form__uploadProfile__picture" src={previewUrl ? previewUrl : ICONS.defaultUserIcon} alt="" />
              <span className="form__uploadProfile__overlay">
                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.4782 12.1589C15.4782 12.5125 15.3377 12.8516 15.0877 13.1017C14.8376 13.3517 14.4985 13.4922 14.1449 13.4922H2.14486C1.79124 13.4922 1.4521 13.3517 1.20205 13.1017C0.951999 12.8516 0.811523 12.5125 0.811523 12.1589V4.82552C0.811523 4.4719 0.951999 4.13276 1.20205 3.88271C1.4521 3.63266 1.79124 3.49219 2.14486 3.49219H4.81152L6.14486 1.49219H10.1449L11.4782 3.49219H14.1449C14.4985 3.49219 14.8376 3.63266 15.0877 3.88271C15.3377 4.13276 15.4782 4.4719 15.4782 4.82552V12.1589Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M8.14486 10.8255C9.61762 10.8255 10.8115 9.63161 10.8115 8.15885C10.8115 6.68609 9.61762 5.49219 8.14486 5.49219C6.6721 5.49219 5.47819 6.68609 5.47819 8.15885C5.47819 9.63161 6.6721 10.8255 8.14486 10.8255Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </label>
            {(displayedAbhaNumber) && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  background: '#fff',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  padding: '6px 12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  zIndex: 2
                }}
              >
                <span style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                  ABHA Number: {displayedAbhaNumber}
                </span>
                <span
                  style={{ cursor: 'pointer' }}
                  title="Copy ABHA Number"
                  onClick={() => {
                    navigator.clipboard.writeText(displayedAbhaNumber);
                  }}
                >
                  <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <rect x="4" y="4" width="8" height="8" rx="2" fill="#555"/>
                    <rect x="2" y="2" width="8" height="8" rx="2" stroke="#555" strokeWidth="1"/>
                  </svg>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      {data?.state?.mode === "create" && (
        <Formik
          initialValues={{ abhaNumber: "", aadhaarNumber: "", idType: '', orgID: '' }}
          validationSchema={Yup.object({
            abhaNumber: Yup.string()
              .matches(
                /^\d{2}-\d{4}-\d{4}-\d{4}$/,
                "ABHA Number must follow the format XX-XXXX-XXXX-XXXX"
              ),
            aadhaarNumber: Yup.string()
              .matches(
                /^\d{12}$/,
                "Aadhaar Number must be exactly 12 digits"
              ),
          })}
          onSubmit={handleAbhaSubmit}
        >
          {({ errors, values, handleChange, handleBlur, touched, setFieldValue }) => (
            <Form>
              <div className="formRow formRow__2">
                <div className='formCol'>
                  <div className="form__Field">
                  <div className='formRow formRow__2'>
                    <div className="formCol">
                      <div className="form__Field">
                        <label className="form__label" htmlFor="abhaNumber">
                          ABHA Number
                        </label>
                        <input
                          type="text"
                          id="abhaNumber"
                          name="abhaNumber"
                          placeholder="XX-XXXX-XXXX-XXXX"
                          onChange={(e) => {
                            handleChange(e);
                            setErrorMessage("");
                          }}
                          onBlur={handleBlur}
                          maxLength={17}
                          value={values.abhaNumber}
                          className="form__input form__input--sm"
                        />
                        {touched.abhaNumber && errors.abhaNumber && (
                          <div className="text-sm error text-error">
                            {errors.abhaNumber}
                          </div>
                        )}
                        {errorMessage && (
                          <div className="text-sm error text-error">{errorMessage}</div>
                        )}
                      </div>
                    </div>
                    <div className="formCol">
                      <div className="form__Field">
                        <label className="form__label">&nbsp;</label>
                        <div className="btn__group">
                          <button
                            className="btn btn__primary"
                            type="button"
                            disabled={!values.abhaNumber || !!errors.abhaNumber}
                            onClick={() => handleGetOtp(values.abhaNumber)}
                          >
                            Send OTP
                          </button>
                          <button
                            className="btn btn__primary"
                            type="button"
                            onClick={() => {
                              setShowAadhaarPopup(true);
                              dispatch(clearSendAbhaOtpState());
                              setErrorMessage("");
                              setFieldValue('aadhaarNumber', '');
                              setFieldValue('abhaNumber', '');
                            }}
                          >
                            + Enroll
                          </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {hospitalDetailsData?.result?.government && (
                  <div className='formCol'>
                    <div className="formRow formRow__2 flex items-center gap-6">
                      <div className="formCol">
                        <div className="form__radio flex gap-4 mt-8">
                          {idOptions.map((option) => (
                            <label key={option.value} className="flex items-center custom-radio-container">
                              <input
                                type="radio"
                                name="idType"
                                value={option.value}
                                checked={option.value === values.idType}
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue('orgID', '');
                                  handleOrganizationId(e.target.value, values.orgID);
                                }}
                                className="form__radio__input"
                              />
                              <span className="form__radio__label">{option.label}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                      <div className="formCol">
                        <div className="form__Field flex flex-col">
                          <label className="form__label text-base font-medium mb-1" htmlFor="orgID">
                            {(() => {
                              const label = idOptions.find((option) => option.value === values.idType)?.label
                                ? `${idOptions.find((option) => option.value === values.idType)?.label} ID`
                                : 'ID';
                              return label === 'Government ID' ? (
                                <>
                                  {label}
                                  <span className="required-asterisk text-red-500">*</span>
                                </>
                              ) : (
                                label
                              );
                            })()}
                          </label>
                          <input
                            type="text"
                            id="orgID"
                            name="orgID"
                            placeholder="XX-XXXX-XXXX-XXXX"
                            onChange={(e) => {
                              handleChange(e);
                              setFieldValue('orgID', e.target.value);
                              handleOrganizationId(values.idType, e.target.value);
                              setErrorMessage("");
                            }}
                            onBlur={handleBlur}
                            value={values.orgID || ''}
                            disabled={!values.idType}
                            className="form__input form__input--sm border border-gray-300 rounded-full p-2 text-base w-64 focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                          />
                          <ErrorMessage name="orgID" component="div" className="error text-error" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
                {showAadhaarPopup && (
                  <div className="popup-overlay">
                    <div className="popup-container">
                      <h2 className="mb-5 popup-heading">Enroll ABHA via Aadhaar</h2>
                      <p className="popup-para">Enter Aadhaar Number to enroll</p>
                      <div className='formCol'>
                        <div className="form__Field">
                          <input
                            type="text"
                            id="aadhaarNumber"
                            name="aadhaarNumber"
                            placeholder="Enter 12-digit Aadhaar Number"
                            onChange={(e) => {
                              const value = e.target.value.replace(/[^0-9]/g, '');
                              handleChange(e);
                              e.target.value = value;
                              setAadhaarErrorMessage("");
                            }}
                            onBlur={handleBlur}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                              }
                            }}
                            maxLength={12}
                            value={values.aadhaarNumber}
                            className="form__input form__input--sm"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {touched.aadhaarNumber && errors.aadhaarNumber && (
                            <div className="text-sm error text-error">
                              {errors.aadhaarNumber}
                            </div>
                          )}
                          {aadhaarErrorMessage && (
                            <div className="text-sm error text-error">{aadhaarErrorMessage}</div>
                          )}
                        </div>
                      </div>
                      <div className="popup-actions text-left">
                        <button
                          className="custom-button main-theme"
                          type="button"
                          onClick={() => {
                            handleAadhaarEnroll(values.aadhaarNumber);
                          }}
                          disabled={!values.aadhaarNumber || !!errors.aadhaarNumber}
                        >
                          Submit
                        </button>
                        <button
                          className="custom-button"
                          style={{ color: '#000000', borderColor: '#000000' }}
                          onClick={() => {
                            setShowAadhaarPopup(false);
                            setFieldValue('aadhaarNumber', '');
                            setAadhaarErrorMessage("");
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}
            {aadhaarAbhaModal.open && (
              <div className="popup-overlay">
                <div className="popup-container">
                  <h2 className="mb-5 popup-heading">
                    {aadhaarAbhaModal.message === "This account already exist"
                      ? "Account Already Exists"
                      : "ABHA Number Created"}
                  </h2>
                  <p className="popup-para">
                    {aadhaarAbhaModal.message === "This account already exist"
                      ? "This account already exists. Your ABHA number is: "
                      : "Your ABHA number is: "}
                    <strong style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                      {aadhaarAbhaModal.abhaNumber}
                      <span
                        style={{ cursor: 'pointer' }}
                        title="Copy ABHA Number"
                        onClick={() => {
                          navigator.clipboard.writeText(aadhaarAbhaModal.abhaNumber);
                        }}
                      >
                        {/* Simple copy icon SVG */}
                        <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                          <rect x="4" y="4" width="8" height="8" rx="2" fill="#555"/>
                          <rect x="2" y="2" width="8" height="8" rx="2" stroke="#555" strokeWidth="1"/>
                        </svg>
                      </span>
                    </strong>
                  </p>
                  <div className="popup-actions text-left">
                    <button
                      className="custom-button main-theme"
                      onClick={() => setAadhaarAbhaModal({ open: false, abhaNumber: "", message: "" })}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showAadhaarOTPPopup && (
              <div className="popup-overlay">
                <div className="popup-container">
                  <h2 className="mb-5 popup-heading">Verify Aadhaar OTP</h2>
                  <p className="popup-para">Enter OTP and Mobile Number</p>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor="txnId">Transaction ID</label>
                      <input
                        type="text"
                        id="txnId"
                        name="txnId"
                        value={aadhaarTxnId}
                        disabled
                        className="form__input form__input--sm"
                      />
                    </div>
                    <div className="form__Field">
                      <label className="form__label" htmlFor="otp">OTP</label>
                      <input
                        type="text"
                        id="otp"
                        name="otp"
                        placeholder="Enter OTP"
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          setAadhaarOTP(value);
                        }}
                        value={aadhaarOTP}
                        maxLength={6}
                        className="form__input form__input--sm"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                      {verifyOtpErrorMessage && (
                        <div className="text-sm error text-error">{verifyOtpErrorMessage}</div>
                      )}
                    </div>
                    <div className="form__Field">
                      <label className="form__label" htmlFor="mobile">Mobile Number</label>
                      <input
                        type="text"
                        id="mobile"
                        name="mobile"
                        placeholder="Enter Mobile Number"
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          setAadhaarMobile(value);
                        }}
                        value={aadhaarMobile}
                        maxLength={10}
                        className="form__input form__input--sm"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                  </div>
                  <div className="popup-actions text-left">

                    <button
                      className="custom-button main-theme"
                      onClick={() => handleAadhaarOTPSubmit(aadhaarOTP, aadhaarMobile)}
                      disabled={aadhaarOTP.length !== 6 || aadhaarMobile.length !== 10}
                    >
                      Submit
                    </button>
                    <button
                      className="custom-button"
                      style={{ color: '#000000', borderColor: '#000000' }}
                      onClick={() => {
                        setShowAadhaarOTPPopup(false);
                        setAadhaarOTP("");
                        setAadhaarMobile("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
            </Form>
          )}
        </Formik>
      )}

      <Formik
        initialValues={initialValues}
        validationSchema={PatientDemographicFormSchema}
        onSubmit={handleSave}
        enableReinitialize
      >
        {({
          errors,
          values,
          handleChange,
          handleBlur,
          touched,
          setFieldValue,
        }) => {
          // Sync Age and DOB
          useEffect(() => {
            if (values.dob && (!values.age || values.age === '' || values.age !== calculateAgeFromDOB(values.dob))) {
              const age = calculateAgeFromDOB(values.dob);
              if (age !== values.age) setFieldValue('age', age);
            }
          }, [values.dob]);
          useEffect(() => {
            if (values.age && values.age !== '' && (!values.dob || calculateAgeFromDOB(values.dob) !== values.age)) {
              const dob = calculateDOBFromAge(values.age);
              if (!values.dob || !dayjs(values.dob).isSame(dob, 'year')) setFieldValue('dob', dob);
            }
          }, [values.age]);

          function calculateAgeFromDOB(dob) {
            if (!dob) return '';
            const today = dayjs();
            let age = today.year() - dayjs(dob).year();
            if (today.month() < dayjs(dob).month() || (today.month() === dayjs(dob).month() && today.date() < dayjs(dob).date())) {
              age--;
            }
            return age.toString();
          }
          function calculateDOBFromAge(age) {
            const today = dayjs();
            // Set DOB to Jan 1st of (today's year - age)
            return today.subtract(Number(age), 'year');
          }

          useEffect(() => {
            if (data?.state?.mode !== 'edit') {
              setFieldValue('phoneNumberCountryCode', selectedCountryCode);
              setFieldValue('whatsappNumberCountryCode', selectedCountryCode);
              setFieldValue('alternateNumberCountryCode', selectedCountryCode);
            }
          }, [selectedCountryCode, data?.state?.mode]);
          return (
          <Form >
             <div className='formRow formRow__4'>
                <div className='formCol'>
                  <div className="form__Field">
                    <label className="form__label" htmlFor='firstName'>
                      First Name
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      placeholder="First Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.firstName}
                      className="form__input form__input--sm"
                    />
                    <ErrorMessage name="firstName" component="div" className="error text-error" />

                  </div>
                </div>
                <div className='formCol'>
                  <div className="form__Field">
                    <label className="form__label">
                      Middle Name/Initial
                    </label>
                    <input
                      type="text"
                      id="middleName"
                      name="middleName"
                      placeholder="Middle Name/Initial"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.middleName}
                      className="form__input form__input--sm"
                    />

                  </div>
                </div>
                <div className='formCol'>
                  <div className="form__Field">
                    <label className="form__label" htmlFor='lastName'>Last Name<span className="required-asterisk">*</span></label>
                    <input
                      className="form__input form__input--sm"
                      type="text"
                      id="lastName"
                      name="lastName"
                      placeholder="Last Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastName}
                    />
                    <ErrorMessage name="lastName" component="div" className="error text-error" />
                  </div>
                </div>
                <div className='formCol'>
                  <div className="form__Field">
                    <label className="form__label" htmlFor='gender'>Gender<span className="required-asterisk">*</span></label>
                    <div className='form__radio'>
                      {genderOptions.map((option) => (
                        <label key={option.value} className="flex items-center mr-8 mt-2 custom-radio-container">
                          <input
                            type="radio"
                            name="gender"
                            value={option.value}
                            checked={option.value === values?.gender}
                            onChange={handleChange}
                            className="form__radio__input"
                          />
                          <span className="form__radio__label">{option.label}</span>
                        </label>
                      ))}
                    </div>
                    <ErrorMessage name="gender" component="div" className="error text-error" />
                  </div>
                </div>
              </div>
              <div className='formRow formRow__4'>
                <div className='formCol'>
                  <div className="form__Field">
                    <label className="form__label" htmlFor='emailId'>Email ID</label>
                    <input
                      type="email"
                      id="emailId"
                      name="emailId"
                      placeholder="Email ID"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form__input form__input--sm"
                      value={values.emailId}
                    />
                    <ErrorMessage name="emailId" component="div" className="error text-error" />
                  </div>
                </div>
                <div className='formCol'>
                  <div className="form__Field">
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
                      <div style={{ width: '50%' }}>
                        <label className="form__label" htmlFor='dob'>Date of Birth<span className="required-asterisk">*</span></label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Field name="dob">
                            {({ field }) => (
                              <DatePicker
                                sx={{
                                  width: '100%',
                                  '& .MuiInputBase-root': {
                                    backgroundColor: '#F6FFFF',
                                    borderRadius: '2rem'
                                  },
                                  '& .MuiInputBase-input': {
                                    padding: '10px',
                                  },
                                }}
                                {...field}
                                value={field.value || null}
                                format="DD/MM/YYYY"
                                maxDate={dayjs()}
                                onChange={(newValue) => {
                                  setFieldValue(field.name, newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={touched.date && Boolean(errors.date)}
                                    helperText={touched.date && errors.date}
                                  />
                                )}
                              />
                            )}
                          </Field>
                        </LocalizationProvider>
                        <ErrorMessage name="dob" component="div" className="error text-error" />
                      </div>
                      <div style={{ width: '50%' }}>
                        <label className="form__label" htmlFor='age'>Age<span className="required-asterisk">*</span></label>
                        <Field name="age">
                          {({ field }) => (
                            <input
                              type="number"
                              id="age"
                              name="age"
                              min={0}
                              max={150}
                              className="form__input form__input--sm"
                              placeholder="Age"
                              value={field.value || ''}
                              onChange={e => {
                                let val = e.target.value.replace(/[^0-9]/g, '');
                                if (val.length > 3) val = val.slice(0, 3);
                                setFieldValue('age', val);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMessage name="age" component="div" className="error text-error" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='formCol'>
                  <div className="form__Field">
                    <label className="form__label" htmlFor='height'>Height(Cm)</label>
                    <input
                      type="number"
                      id="height"
                      name="height"
                      placeholder="--"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.height}
                      className="form__input form__input--sm"
                    />
                    <ErrorMessage name="height" component="div" className="error text-error" />
                  </div>
                </div>
                <div className='formCol'>
                  <div className="form__Field">
                    <label className="form__label" htmlFor='weight'>Weight(Kg)</label>
                    <input
                      type="number"
                      id="weight"
                      placeholder="--"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.weight}
                      className="form__input form__input--sm"
                    />
                    <ErrorMessage name="weight" component="div" className="error text-error" />
                  </div>
                </div>
              </div>
              <div className='formRow formRow__4'>
                <div className='formCol'>
                  <div className='form__Field'>
                    <label className="form__label" htmlFor='bloodGroup' >Blood Group</label>
                    <select
                      id="bloodGroup"
                      name="bloodGroup"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.bloodGroup}
                      autoComplete='off'
                      style={customStyle.select}
                      className="form__select form__select--sm"
                    >
                      <option value="">Select</option>
                      {bloodGroup.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='formCol'>
                  <div className='form__Field'>
                    <label className="form__label" htmlFor='maritalStatus'>Marital Status<span className="required-asterisk">*</span></label>
                    <div className='form__radio'>
                      {martialOption.map((option) => {
                        return <label key={option.value} className='flex justify-center items-center custom-radio-container mt-2'>
                          <input
                            type="radio"
                            id="maritalStatus"
                            name="maritalStatus"
                            onChange={handleChange}
                            value={option.value}
                            className='form__radio__input'
                            checked={option.value === values.maritalStatus}
                          />
                          <span className="form__radio__label">{option.label}</span>
                        </label>
                      })}
                    </div>
                    <ErrorMessage name="maritalStatus" component="div" className="error text-error" />
                  </div>
                </div>
              </div>

                <h1 className='form__section__title'>Contact Information</h1>
                <div className='formRow formRow__4'>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='homeAddress'>Home Address<span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        id="homeAddress"
                        name="homeAddress"
                        placeholder="Home Address"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.homeAddress}
                        className="form__input form__input--sm"
                      />
                      <ErrorMessage name="homeAddress" component="div" className="error text-error" />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='name'>
                        Contact Number<span className="required-asterisk">*</span>
                      </label>
                      <div className='form__groupField form__groupField--phonenumber'>
                        <select id="phoneNumberCountryCode"
                          name="phoneNumberCountryCode"
                          className="form__select form__select--sm"
                          style={customStyle.select}
                          value={values.phoneNumberCountryCode}
                          onChange={(e) => {
                            setFieldValue('phoneNumberCountryCode', e.target.value);
                            if (values.sameAsPhoneNo) {
                              setFieldValue('whatsappNumberCountryCode', e.target.value);
                            }
                          }}>
                          {contactCountryCode.map((option) => (
                            <option
                              key={option}
                              value={option}
                            >
                              {option}
                            </option>
                          ))}
                        </select>
                        <input type="text"
                          id="phoneNumber"
                          name="phoneNumber"
                          className="form__input form__input--sm"
                          placeholder="Contact Number"
                          maxLength={10}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            handleChange(e);
                          }}
                          pattern="[0-9]*"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          value={values.phoneNumber}>
                        </input>
                      </div>
                      <ErrorMessage name="phoneNumber" component="div" className="error text-error" />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='name'>
                        Alternate Number
                      </label>
                      <div className='form__groupField form__groupField--phonenumber'>
                        <select id="alternateNumberCountryCode"
                          name="alternateNumberCountryCode"
                          value={values.alternateNumberCountryCode}
                          className="form__select form__select--sm"
                          style={customStyle.select}
                          onChange={(e) => {
                            setFieldValue('alternateNumberCountryCode', e.target.value);
                          }}>
                          {contactCountryCode.map((option) => (
                            <option
                              key={option}
                              value={option}
                            >
                              {option}
                            </option>
                          ))}
                        </select>
                        <input type="text"
                          id="alternateNumber"
                          name="alternateNumber"
                          maxLength={10}
                          className="form__input form__input--sm"
                          pattern="[0-9]*"
                          placeholder="Alternate Number"
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            handleChange(e);
                          }}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          value={values.alternateNumber}>
                        </input>
                      </div>
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='whatsappNumberCountryCode'>Whatsapp Number<span className="required-asterisk">*</span></label>
                      <div className='form__groupField form__groupField--phonenumber'>
                        <select
                          className="form__select form__select--sm"
                          style={customStyle.select}
                          id="whatsappNumberCountryCode"
                          name="whatsappNumberCountryCode"
                          value={values.whatsappNumberCountryCode}
                          onChange={(e) => {
                            setFieldValue('whatsappNumberCountryCode', e.target.value);
                          }}
                          disabled={sameAsPhoneNo}
                        >
                        {contactCountryCode.map((option) => (
                          <option
                            key={option}
                            value={option}
                          >
                            {option}
                          </option>
                        ))}
                        </select>
                        <input
                          type="text"
                          id="whatsappNumber"
                          name="whatsappNumber"
                          placeholder="Whatsapp Number"
                          maxLength={10}
                          className="form__input form__input--sm"
                          onChange={handleChange}
                          pattern="[0-9]*"
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          disabled={sameAsPhoneNo || values.whatsappNumber == values.phoneNumber}
                          value={sameAsPhoneNo ? values.whatsappNumber = values.phoneNumber : values.whatsappNumber} />
                      </div>
                      <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                      <div className='form__checkboxSubField'>
                        <div className='form__checkbox'>
                          <div className="form__checkbox__option m_0">
                            <input
                              className="form__checkbox__input"
                              id="sameAsPhoneNo"
                              checked={values.whatsappNumber === values.phoneNumber && values.whatsappNumber !== ''}
                              type="checkbox"
                              name="sameAsPhoneNo"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setSameAsPhoneNo(isChecked);
                                setFieldValue('sameAsPhoneNo', isChecked);
                                if (isChecked) {
                                  setFieldValue('whatsappNumber', values.phoneNumber);
                                  countryCode.whatsappNumberCountryCode = countryCode.phoneNumberCountryCode;
                                } else {
                                  setFieldValue('whatsappNumber', '');
                                  countryCode.whatsappNumberCountryCode = '+91';
                                }
                              }}
                            />
                            <label className="form__checkbox__label">Same as Contact Number</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='formRow formRow__4'>
                  <div className='formCol'>
                    <div className='form__Field'>
                      <label className="form__label" htmlFor='country' >Country</label>
                      <select
                        id="country"
                        name="country"
                        className="form__select form__select--sm"
                        onChange={(e) => {
                          handleChange(e);
                          fetchStates(e.target.value, '', 'state')
                        }}
                        onBlur={handleBlur}
                        value={values.country}
                        style={customStyle.select}
                      >
                        <option value="">-Select-</option>
                        {countryList.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className='form__Field'>
                      <label className="form__label" htmlFor='state'>State</label>
                      <select
                        id="state"
                        name="state"
                        className="form__select form__select--sm"
                        onChange={(e) => {
                          handleChange(e);
                          fetchStates(values.country, e.target.value, 'city')
                        }}
                        onBlur={handleBlur}
                        value={values.state}
                        style={customStyle.select}
                      >
                        <option value="">-Select-</option>
                        {states.map((option) => (
                          <option key={option.isoCode} value={option.isoCode}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className='form__Field'>
                      <label className="form__label" htmlFor='city'>City</label>
                      <select
                        id="city"
                        name="city"
                        className="form__select form__select--sm"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.city}
                        style={customStyle.select}
                      >
                        <option value="">-Select-</option>
                        {cities.map((option) => (
                          <option key={option.name} value={option.name}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='zipCode'>Zip Code</label>
                      <input
                        type="text"
                        id="zipCode"
                        name="zipCode"
                        placeholder="ZipCode"
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          e.target.value = value;
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        maxLength={6}
                        value={values.zipCode}
                        className="form__input form__input--sm"
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                    </div>
                    <ErrorMessage name="zipCode" component="div" className="error text-error" />
                  </div>
                </div>
                <div className='btn__group' >
                  <button
                    className='btn btn__primary'
                    type="submit"
                  >
                    Next
                  </button>
                  <button
                    className='btn btn__white'
                    onClick={cancel}
                  >
                    Cancel
                  </button>
                </div>

          </Form>
        )}}
      </Formik>
      {showEnterOTPPopup &&
        <div className="popup-overlay">
          <div className="popup-container">
            <h2 className="mb-5 popup-heading">Enter OTP</h2>
            <p className="popup-para"></p>
            <div className='formCol'>
              <div className="form__Field">
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  placeholder="Enter OTP"
                  onChange={(e) => {
                    const value = e.target.value;
                    const numericValue = value.replace(/[^0-9]/g, '');
                    if (numericValue.length <= 6) {
                      setOTP(numericValue);
                    }
                  }}
                  value={OTP}
                  maxLength={6}
                  className="form__input form__input--sm"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  autoComplete="one-time-code"
                />
              </div>
              {verifyErrorMessage && (
                <div className="text-sm error text-error">{verifyErrorMessage}</div>
              )}
            </div>
            <div className={`popup-actions text-left text-left`}>

              <button className="custom-button main-theme" onClick={() => {
                handleSubmitOtp(OTP)
              }}>
                Submit
              </button>
              <button
                className="custom-button"
                style={{ color: '#000000', borderColor: '#000000' }}
                onClick={() => {
                  setShowEnterOTPPopup(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      }

      <Loader isLoaderOpen={load || verifyAbhaOtpEnrollLoading || enrollAbhaLoading} />
      <SuccessModal
        isSuccessModalOpen={successModal}
        title={successMessage}
        handleCloseModal={() => {
          setSuccessModal(false);
        }}
      />
    </section>
  )
}

export default PatientDemoGraphics
